// Paleta de colores corporativos HSS basada en el logo
export const hssColors = {
  // Colores principales del logo
  primary: '#3b5998',        // Azul principal HSS
  primaryLight: '#5875b8',   // Azul claro
  primaryDark: '#2d4373',    // Azul oscuro

  // Colores secundarios
  secondary: '#e74c3c',      // Rojo/Naranja del logo
  accent: '#f39c12',         // Dorado/Amarillo

  // Grises corporativos
  gray50: '#f8f9fa',
  gray100: '#e9ecef',
  gray200: '#dee2e6',
  gray300: '#ced4da',
  gray400: '#adb5bd',
  gray500: '#6c757d',
  gray600: '#495057',
  gray700: '#343a40',
  gray800: '#212529',

  // Estados
  success: '#27ae60',
  warning: '#f39c12',
  error: '#e74c3c',
  info: '#3498db',

  // Fondos
  backgroundPrimary: '#f5f7fa',
  backgroundSecondary: '#ffffff',
  backgroundDark: '#2c3e50',

  // Texto
  textPrimary: '#2c3e50',
  textSecondary: '#7f8c8d',
  textLight: '#bdc3c7',
  textWhite: '#ffffff',
};

// Configuración del tema para Ant Design
export const antdTheme = {
  token: {
    colorPrimary: hssColors.primary,
    colorSuccess: hssColors.success,
    colorWarning: hssColors.warning,
    colorError: hssColors.error,
    colorInfo: hssColors.info,

    colorLink: hssColors.primary,
    colorLinkHover: hssColors.primaryLight,
    colorLinkActive: hssColors.primaryDark,

    borderRadius: 8,

    colorBgContainer: hssColors.backgroundSecondary,
    colorBgLayout: hssColors.backgroundPrimary,

    fontSize: 14,
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',

    // Sombras
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
    boxShadowSecondary: '0 4px 12px rgba(0, 0, 0, 0.15)',
  },
  components: {
    Button: {
      primaryShadow: '0 2px 4px rgba(59, 89, 152, 0.3)',
      dangerShadow: '0 2px 4px rgba(231, 76, 60, 0.3)',
    },
    Card: {
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
    },
  },
};

// Estilos comunes reutilizables
export const commonStyles = {
  // Gradientes
  gradientPrimary: `linear-gradient(135deg, ${hssColors.primary} 0%, ${hssColors.primaryDark} 100%)`,
  gradientSecondary: `linear-gradient(135deg, ${hssColors.secondary} 0%, ${hssColors.accent} 100%)`,

  // Sombras
  shadowSm: '0 1px 3px rgba(0, 0, 0, 0.12)',
  shadowMd: '0 4px 6px rgba(0, 0, 0, 0.1)',
  shadowLg: '0 10px 20px rgba(0, 0, 0, 0.15)',
  shadowXl: '0 20px 40px rgba(0, 0, 0, 0.2)',

  // Bordes
  borderLight: `1px solid ${hssColors.gray200}`,
  borderMedium: `1px solid ${hssColors.gray300}`,

  // Transiciones
  transition: 'all 0.3s ease',
  transitionFast: 'all 0.15s ease',
};